import type { SVGProps } from "react";
const SvgIconMail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M821 256H203c-41.35 0-75 33.65-75 75v362c0 41.36 33.65 75 75 75h618c41.36 0 75-33.64 75-75V331c0-41.35-33.64-75-75-75m-642.73 71.36 220.06 173.13L178 691.55V331c0-1.24.09-2.45.27-3.64m380.1 162.45c-27.3 21.48-65.44 21.48-92.75 0L231.98 306h560.03zM438.42 531.9c21.98 16.03 47.77 24.06 73.58 24.06s51.61-8.03 73.58-24.06L800.18 718H223.82zm187.25-31.41 220.06-173.13c.17 1.19.27 2.4.27 3.64v360.55z" />
  </svg>
);
export default SvgIconMail;
